export default __webpack_public_path__ + "static/media/solution-cutting.dcb93b1b.png";